import { QRCodeCanvas } from "qrcode.react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CircularLoader from "../../components/Loader/CircularLoader";
import { MyButton } from "../../Hooks/useButton";
import { loadCylinders } from "../../redux/admin/actions/admin.actions";
import style from "./Details.module.scss";

const CylinderDetails = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const code = localStorage.getItem("code");
  const { cylinders } = useSelector((state) => state.adminReducer);

  let match = cylinders?.find((cy) => cy?.cylinder === code);

  function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  useEffect(
    () => async () => {
      setLoading(true);
      await delay(2000);

      dispatch(loadCylinders());

      setLoading(false);
    },
    [dispatch]
  );

  function delay(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  const qrRef = useRef();

  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-${match?.cylinder}.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const qrcode = (
    <QRCodeCanvas
      id='qrCode'
      value={match?.cylinder}
      size={200}
      bgColor={"white"}
      level={"H"}
    />
  );

  return loading ? (
    <div className={style.loading}>
      <CircularLoader />
    </div>
  ) : (
    <div className={style.detailsContainer}>
      <div className={style.qrcode__container}>
        <div ref={qrRef}>{qrcode}</div>
      </div>
      <div className={style.container}>
        <div className={style.detail}>
          <p className={style.title}>Code:</p>
          <p className={style.text}>{match?.cylinder}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>Dispatch Rider:</p>
          <p className={style.text}>{match?.agent}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>Last Scan:</p>
          <p className={style.text}>{match?.location_name}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>Last Scan Address:</p>
          <p className={style.text}>{match?.address}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>Last Scan Date:</p>
          <p className={style.text}>{match?.last_scan}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>Status:</p>
          <p className={style.text}>{match?.status}</p>
        </div>
        <div className={style.detail}>
          <p className={style.title}>
            Days{match?.status === "in" ? " In:" : " Out:"}{" "}
          </p>
          <p className={style.text}>{match?.since}</p>
        </div>
      </div>

      <MyButton
        text='Download QR'
        onClick={downloadQRCode}
        btnClass='w-100 mt-2'
      />
    </div>
  );
};

export default CylinderDetails;
